import { render, staticRenderFns } from "./ShopNickEditComponent.vue?vue&type=template&id=19d232a2&scoped=true"
import script from "./ShopNickEditComponent.vue?vue&type=script&lang=js"
export * from "./ShopNickEditComponent.vue?vue&type=script&lang=js"
import style0 from "./ShopNickEditComponent.vue?vue&type=style&index=0&id=19d232a2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19d232a2",
  null
  
)

export default component.exports